import ScrollToTopOnMount from "../../components/ScrollToTopOnMount/ScrollToTopOnMount";
import Activity from "../../layouts/Activity/Activity";

const ActivityPage = () => {
    return (
        <>
            <ScrollToTopOnMount />
            <Activity />
        </>
    )
}

export default ActivityPage;